import React from 'react';

// Import section components.  Each section encapsulates a piece of the
// landing page to keep the top level clean and easy to understand.
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import Allies from './components/Allies';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import FAQ from './components/FAQ';
import WhatsAppFab from './components/WhatsAppFab';

const App = () => {
  return (
    <div>
      <Header />
      <main>
        <Hero />
        <Services />
        <About />
        <Allies />
        <Testimonials />
            <FAQ />
        <Contact />
      </main>
      <Footer />
           <WhatsAppFab />
    </div>
  );
};

export default App;